<img role="presentation" src="/assets/icons/signet-bg.svg" alt class="d-inline mr-2" />
